
import React from 'react';

interface HeaderProps {
  activePage: string;
  handleInviteUser: () => void;
}

const Header = ({ activePage, handleInviteUser }: HeaderProps) => {
  // Return null to render nothing
  return null;
};

export default Header;
